import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import TagsManage from "features/Library/Common/TagsManage/TagsManage";
import { bindAction } from "interfaces";
import { connect } from "react-redux";
import { mapTagsToView } from "features/Library/Common/helpers/tagsHelper";
import { addTagsToExternalLink } from "../state/thunks/externalLinkCommandThunk";
import { fetchExternalLinkTags } from "../state/thunks/externalLinkQueriesThunk";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  tags: mapTagsToView(state.library.externalLinks.details.tags.tags),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  fetchTags: bindAction(fetchExternalLinkTags, dispatch),
  onConfirmAction: bindAction(addTagsToExternalLink, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagsManage);
